import { theme } from '../theme/theme'

export const isMobile = (width: number): boolean => {
  return width < theme.breakpoint.small
}

export const isTablet = (width: number): boolean => {
  return width >= theme.breakpoint.small && width < theme.breakpoint.large
}

export const isTabletOrMobile = (width: number): boolean => {
  return width < theme.breakpoint.medium
}

export const isDesktop = (width: number): boolean => {
  return width >= theme.breakpoint.large
}

export const isLessThanBreakpoint = (width: number, breakpoint: number): boolean => {
  return width < breakpoint
}

export const isMoreThanBreakpoint = (width: number, breakpoint: number): boolean => {
  return width > breakpoint
}
